export default __webpack_public_path__ + "static/media/P305 zu P308.73590c0b.mp3";